import { SimpleProgressBar } from '@/components/common';

import { JobStatus } from '@/features/regulatory-intake/enums';

interface IJobProgress {
  progressCount: number;
  totalCount: number;
  status: JobStatus;
}

export const JobProgress = ({ progressCount, totalCount, status }: IJobProgress) => {
  const getVariant = () => {
    if (status === JobStatus.Running) return 'blue';
    if (status === JobStatus.Completed) return 'green';
    if (status === JobStatus.CompletedWithErrors) return 'yellow';
  };

  return (
    <div className="flex flex-row justify-start items-center gap-2">
      <SimpleProgressBar
        className="h-[8px] w-[302px]"
        value={(progressCount / totalCount) * 100}
        variant={getVariant()}
      />
      <span>
        {progressCount}/{totalCount}
      </span>
    </div>
  );
};
